<template>
    <div id="show-email-modal-container" v-if="!hidden" :class="{opened: !hidden}">
        <div id="show-email-modal">
            <h1>Viewing Email Type: {{ item.email_type }}
                <small>({{ item.status }})</small>
            </h1>
            <h2>Sent To:
                <div v-html="$options.filters.recips(item.to)"></div>
            </h2>
            <h2 v-if="item.cc">CC:
                <div v-html="$options.filters.recips(item.cc)"></div>
            </h2>
            <h2>Contains Attachment: {{ item.has_attachments | human_bool}}</h2>
            <h3>{{ item.subject }}</h3>
            <div v-html="item.body"></div>
            <div class="actions">
                <a href="#" @click.prevent="closeModal()">Go Back</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                hidden: true,
                item: ''
            }
        },
        filters: {
            recips: function (arrayOfRecips) {
                return _.map(arrayOfRecips, function (recip) {
                    return '<a href="mailto:' + recip.email + '">' + recip.name + '</a>';
                }).join(', ');
            }
        },
        computed: {},
        methods: {
            closeModal() {
                this.item = '';
                this.hidden = true;
            },
            openModal() {
                this.hidden = false;
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('show-email-modal-open', function (item, id) {
                that.item = item;
                that.openModal();
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/setup';

    #show-email-modal-container {
        display: none;
        &.opened {
            background-color: #fff;
            position: absolute;
            height: 100vh;
            width: 100vw;
            z-index: 10000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 0;
            left: 0;
            @include desktop() {
                background-color: rgba(255, 255, 255, 0.8);
            }
        }
    }

    #show-email-modal {
        padding: 1em;
        h2 {
            font-size: 14px;
            font-weight: 500;
            div {
                display: inline-block;
            }
        }
        h3 {
            font-size: 14px;
            font-weight: 700;
        }
        h1 small {
            float: right;
            font-weight: 400;
            margin-top: 4px;
        }
        @include grid-column(12);
        @include clearfix();
        @include desktop() {
            background-color: #fff;
            border-radius: $standardBorderRadius;
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
            @include grid-column(5);
        }

        div.actions {
            text-align: left;
            margin-top: 30px;
            a, input[type="submit"] {
                padding: 0.7em 0.7em 0.8em;
                text-decoration: none;
                color: #fff;
                border-radius: $standardBorderRadius;
            }
            input[type="submit"] {
                background-color: $green;
            }
            a {
                background-color: #999;
            }
            @include desktop() {
                float: right;
                text-align: right;
                margin-bottom: 0.5em;
            }
        }
    }
</style>
